export const CATEGORY = {
    ERP: 'erp',
    ECOMMERCE: 'ecommerce',
    CRM: 'crm',
    PIM: 'pim',
    MARKETPLACE: 'marketplace',
    OTHER: 'other'
}

export const CATEGORIES = [
    {
        key: CATEGORY.ERP,
        label: 'ERP',
        role: 'Source',
        description: 'System of record for items, customers, pricing, inventory and orders.'
    },
    {
        key: CATEGORY.ECOMMERCE,
        label: 'eCommerce',
        role: 'Target',
        description: 'Storefront that publishes your catalog and sends orders and customers back.'
    },
    {
        key: CATEGORY.CRM,
        label: 'CRM',
        description: 'Accounts, contacts and sales activity for your customer teams.'
    },
    {
        key: CATEGORY.PIM,
        label: 'Product & media',
        description: 'Enriched product information and media for your catalog.'
    },
    {
        key: CATEGORY.MARKETPLACE,
        label: 'Marketplaces',
        description: 'Sell on third-party marketplaces from one catalog.'
    },
    {
        key: CATEGORY.OTHER,
        label: 'Other',
        description: 'Additional endpoint available for integrations.'
    }
]

export const categoryInfo = (key) => CATEGORIES.find((category) => category.key === key) || CATEGORIES[CATEGORIES.length - 1]
export const FEATURED_SYSTEMS = ['BC', 'Magento', 'Shopify', 'NetSuite', 'F&O']
const API_TYPE_CATEGORY = {
    erp: CATEGORY.ERP,
    ecommerce: CATEGORY.ECOMMERCE
}

const CATALOG = {
    Magento: { name: 'Adobe Commerce (Magento)', vendor: 'Adobe' },
    Nav: { name: 'Dynamics NAV', vendor: 'Microsoft', keywords: 'navision dynamics' },
    GP: { name: 'Dynamics GP', vendor: 'Microsoft', keywords: 'great plains dynamics' },
    Shopify: { name: 'Shopify', vendor: 'Shopify' },
    BC: { name: 'Dynamics 365 Business Central', vendor: 'Microsoft', keywords: 'business central d365 dynamics' },
    NetSuite: { name: 'NetSuite', vendor: 'Oracle' },
    SAP: { name: 'SAP Business One', vendor: 'SAP', keywords: 'b1' },
    AX: { name: 'Dynamics AX', vendor: 'Microsoft', keywords: 'axapta dynamics' },
    Sage: { name: 'Sage', vendor: 'Sage' },
    BigCommerce: { name: 'BigCommerce', vendor: 'BigCommerce' },
    EGE: { name: 'EGE', vendor: 'i95Dev' },
    'F&O': { name: 'Dynamics 365 Finance & Operations', vendor: 'Microsoft', keywords: 'finance operations fno d365 dynamics' },
    '3D Cart': { name: 'Shift4Shop (3dcart)', vendor: 'Shift4', keywords: '3dcart shift4shop' },
    QB: { name: 'QuickBooks', vendor: 'Intuit', keywords: 'quickbooks' },
    QuickBooks: { name: 'QuickBooks', vendor: 'Intuit' },
    CRM: { name: 'Dynamics 365 CRM', vendor: 'Microsoft', category: CATEGORY.CRM, keywords: 'customer engagement dynamics sales' },
    SFCC: { name: 'Salesforce Commerce Cloud', vendor: 'Salesforce', keywords: 'demandware b2c commerce' },
    PimCore: { name: 'Pimcore', vendor: 'Pimcore', category: CATEGORY.PIM, keywords: 'pim product information' },
    imageRelay: { name: 'Image Relay', vendor: 'Image Relay', category: CATEGORY.PIM, keywords: 'dam digital asset media images' },
    Marketplace: { name: 'Marketplaces', vendor: 'i95Dev', category: CATEGORY.MARKETPLACE, keywords: 'amazon ebay channels' },
    TestEndpoint: { name: 'Test endpoint', vendor: 'i95Dev', category: CATEGORY.OTHER, keywords: 'sandbox test' }
}
const categoryOf = (endpoint, entry) => {
    if (entry.category) return entry.category
    return API_TYPE_CATEGORY[String(endpoint.type || '').toLowerCase()] || CATEGORY.OTHER
}
export const describeSystem = (endpoint) => {
    const entry = CATALOG[endpoint.shortName] || {}
    const category = categoryOf(endpoint, entry)
    const info = categoryInfo(category)
    const name = entry.name || endpoint.fullName || endpoint.shortName
    return {
        id: endpoint.id,
        shortName: endpoint.shortName,
        name,
        vendor: entry.vendor || '',
        category,
        categoryLabel: info.label,
        description: entry.description || info.description,
        image: endpoint.image || null,
        isAvailable: endpoint.isActive !== false,
        isFeatured: FEATURED_SYSTEMS.includes(endpoint.shortName),
        searchText: [endpoint.shortName, endpoint.fullName, name, entry.vendor, info.label, entry.keywords].filter(Boolean).join(' ').toLowerCase()
    }
}
export const matchesSearch = (system, term) => {
    const words = term.trim().toLowerCase().split(/\s+/).filter(Boolean)
    return words.every((word) => system.searchText.includes(word))
}
